import { render, staticRenderFns } from "./SurveyFieldsDisplay.vue?vue&type=template&id=2528c14c"
import script from "./SurveyFieldsDisplay.vue?vue&type=script&lang=ts"
export * from "./SurveyFieldsDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports